// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".core--components--app-button-balance[data-v-f05f49ea] {\n  position: absolute;\n  top: -25px;\n  right: 0px;\n}\n.loading-dots[data-v-f05f49ea] {\n  width: 20px;\n}", ""]);
// Exports
module.exports = exports;
